export default __webpack_public_path__ + "static/media/undraw_coding_6mjf.be4cb0c5.svg";